import { ReactNode } from 'react';
import { StyledLayoutWrapper } from './styles';

export interface LayoutProps {
  leftSection?: ReactNode;
  centerSection?: ReactNode;
  rightSection?: ReactNode;
  sectionCount: 2 | 3;
}

export const Layout = ({
  leftSection,
  centerSection,
  rightSection,
  sectionCount = 3,
}: LayoutProps) => (
  <StyledLayoutWrapper sectionCount={sectionCount} className="header-layout-wrapper">
    {leftSection ? <div className="left-section">{leftSection}</div> : null}
    {centerSection ? <div className="center-section">{centerSection}</div> : null}
    {rightSection ? <div className="right-section">{rightSection}</div> : null}
  </StyledLayoutWrapper>
);

export default Layout;
